import * as payService from '../../service/PayService'
import  * as types from '../mutation-types'

const payModule = {
    state: () => ({
        authLinkNum: 0,                     // 登录后更新公众号B授权开关number
        savePageData: {},                 // 保存当前页需要的数据object
        backApiCall: false,                 // 返回页面是否要调用接口boolean 是-true
        paramsHome: {},                   // payHome页面参数object
        paramsResult: {},                 // payResult页面参数object
        pageHomeData: {},                 // payHome页面数据object
        pageResultData: {},               // payResult页面数据object
    }),
    getters: {
        authLinkNum: state => state.authLinkNum,
        savePageData: state => state.savePageData,
        backApiCall: state => state.backApiCall,
        paramsHome: (state) => state.paramsHome,
        paramsResult: (state) => state.paramsResult,
        pageHomeData: (state) => state.pageHomeData,
        pageResultData: (state) => state.pageResultData,
    },
    mutations: {
        [types.SET_AUTH_LINK_NUM](state,options){
            state.authLinkNum = options;
        },
        [types.SET_SAVE_PAGE_DATA](state,options) {
            state.savePageData = options;
        },
        [types.SET_BACK_API_CALL](state,options) {
            state.backApiCall = options;
        },
        [types.SET_PARAMS_HOME](state,options){
            state.paramsHome = options;
        },
        [types.SET_PARAMS_RESULT](state,options){
            state.paramsResult = options;
        },
        [types.SET_PAGE_HOME_DATA](state,options){
            state.pageHomeData = options;
        },
        [types.SET_PAGE_RESULT_DATA](state,options){
            state.pageResultData = options;
        },
    },
    actions: {
        setSavePageData({commit},options){
            commit('SET_SAVE_PAGE_DATA',options)
        },
        setBackApiCall({commit},options){
            commit('SET_BACK_API_CALL',options)
        },
        setPageHomeData({commit},options){
            commit('SET_PAGE_HOME_DATA',options)
        },
        setPageResultData({commit},options){
            commit('SET_PAGE_RESULT_DATA',options)
        }
    }
}

export default payModule